import { render, staticRenderFns } from "./AuthSubmitButton.vue?vue&type=template&id=05fbcfa6&scoped=true&"
import script from "./AuthSubmitButton.vue?vue&type=script&lang=js&"
export * from "./AuthSubmitButton.vue?vue&type=script&lang=js&"
import style0 from "./AuthSubmitButton.vue?vue&type=style&index=0&id=05fbcfa6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fbcfa6",
  null
  
)

export default component.exports